import { render, staticRenderFns } from "./ToolbarBackButtonComponent.vue?vue&type=template&id=5061d275&"
import script from "./ToolbarBackButtonComponent.vue?vue&type=script&lang=js&"
export * from "./ToolbarBackButtonComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarBackButtonComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports